import { render, staticRenderFns } from "./translation-input.vue?vue&type=template&id=3871315c&"
import script from "./translation-input.vue?vue&type=script&lang=js&"
export * from "./translation-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cristi\\Documents\\Work\\www\\tpdemo\\wp-content\\plugins\\translatepress\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3871315c', component.options)
    } else {
      api.reload('3871315c', component.options)
    }
    module.hot.accept("./translation-input.vue?vue&type=template&id=3871315c&", function () {
      api.rerender('3871315c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/src/js/components/translation-input.vue"
export default component.exports